import axios from 'axios';

const API = axios.create({
  baseURL: '/api',
  withCredentials: true,
});

API.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Token ${token}`;
  return config;
});

export const login = (username, password) =>
  axios.post('/api-auth/login/', { username, password });

export const getPartnerships = () => API.get('/partnerships/');
export const getPartnership = (id) => API.get(`/partnerships/${id}/`);
export const createPartnership = (data) => API.post('/partnerships/', data);

export const getPartners = (partnershipId) =>
  API.get(`/partners/?partnership=${partnershipId}`);
export const createPartner = (data) => API.post('/partners/', data);

export const getCycles = (partnershipId) =>
  API.get(`/cycles/?partnership=${partnershipId}`);
export const createCycle = (data) => API.post('/cycles/', data);

export const getSessions = (cycleId) =>
  API.get(`/sessions/?cycle=${cycleId}`);
export const createSession = (data) => API.post('/sessions/', data);

export const getExpenses = (partnershipId) =>
  API.get(`/expenses/?partnership=${partnershipId}`);
export const createExpense = (data) => API.post('/expenses/', data);

export default API;
